/* istanbul ignore file */
import { connect } from '@lumapps/redux/react';
import { canAccessCoveoSearchSettings } from '@lumapps/search-coveo-backoffice/ducks/selectors';

import { canAccessSearchSettings } from '../../ducks/selectors';
import {
    SearchSettingsSideNavigation as SearchSettingsSideNavigationUI,
    SearchSettingsSideNavigationProps,
} from './SearchSettingsSideNavigation';

const mapStateToProps = (state: BackOfficeStore, ownProps: { id: string }): SearchSettingsSideNavigationProps => ({
    ...ownProps,
    canAdminNS: canAccessSearchSettings(state),
    canAdminCoveo: canAccessCoveoSearchSettings(state),
});

const Connected = connect(mapStateToProps)(SearchSettingsSideNavigationUI);
Connected.displayName = 'SideNavigationItem';

export { Connected as SearchSettingsSideNavigation };
